import { IModuleNavigationState } from './types';

export const SLICE_NAMESPACE = 'moduleNavigation';

export const initialState: IModuleNavigationState = {
  isLoading: true,
  modulesByPlatform: [],
};
